import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.5rem;

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }
`;

export const Columns = styled.div`
  ${({ grid }) => css`
    display: grid;
    grid-template-columns: repeat(${grid}, 1fr);
    gap: 1.5rem;
  `}
`;
